import { IconGitFork, IconPencil } from '@tabler/icons-react';
import React from 'react';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';

export interface IMessageQuestionActionsProps {
  canEdit: boolean;
  canFork: boolean;
  forking: boolean;
  onEdit: () => void;
  onFork: () => void;
}

/** @registry Edit ("Edit message") and Fork ("Fork from here", starts a new chat) action icons for a user's chat question; the caller decides which one applies. */
export const MessageQuestionActions: React.FC<IMessageQuestionActionsProps> = ({
  canEdit,
  canFork,
  forking,
  onEdit,
  onFork,
}) => (
  <>
    {canEdit && (
      <BasicActionIcon
        size="sm"
        variant="subtle"
        color="gray"
        label="Edit message"
        onClick={onEdit}
      >
        <IconPencil size={16} />
      </BasicActionIcon>
    )}
    {canFork && (
      <BasicActionIcon
        size="sm"
        variant="subtle"
        color="gray"
        label="Fork from here — start a new chat from this message"
        aria-label="Fork from here"
        loading={forking}
        onClick={onFork}
      >
        <IconGitFork size={16} />
      </BasicActionIcon>
    )}
  </>
);
